export default "__VITE_ASSET__DArCDFbr__"